import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./CustomDateRangePicker.scss";

import { DateRangePicker } from "react-date-range";
import format from "date-fns/format";
import {
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";

interface CustomDatePickerProps {
  onStartDateChange: (startDate: Date) => void;
  onEndDateChange: (endDate: Date) => void;
  dateFrom: Date;
  dateTo: Date;
  months: number;
}

export default function CustomDateRangePicker({
  onStartDateChange,
  onEndDateChange,
  months,
  dateFrom,
  dateTo,
}: CustomDatePickerProps): JSX.Element {

  return (
    <Popover placement="bottom-start">
      <>
        <PopoverTrigger>
          <Input
            name="datePicker"
            value={`${format(dateFrom, "dd/MM/yyyy")} to ${format(
              dateTo,
              "dd/MM/yyyy"
            )}`}
            width={{ lg: "13rem" }}
            textAlign="center"
            p={0}
          />
        </PopoverTrigger>
        <PopoverContent width="auto">
          <PopoverBody>
            <DateRangePicker
              onChange={(item: any) => {
                onStartDateChange(item.selection.startDate);
                onEndDateChange(item.selection.endDate);
              }}
              editableDateInputs={true}
              moveRangeOnFirstSelection={false}
              ranges={[
                {
                  startDate: dateFrom,
                  endDate: dateTo,
                  key: "selection",
                },
              ]}
              months={months}
              direction="horizontal"
              className="calendarElement"
              rangeColors={["#38B2AC"]}
            />
          </PopoverBody>
        </PopoverContent>
      </>
    </Popover>
  );
}
